export default __webpack_public_path__ + "static/media/lm_lid.f68906f2.png";